import { faTag } from "@jewlr/pro-regular-svg-icons/faTag"
import { useMemo } from "react"
import { useSelector } from "react-redux"

import FontAwesomeIcon from "components/ui/font-awesome-icon"
import Shimmer from "components/ui/shimmer"
import { cn } from "styles/utils"

const PriceBadge = () => {
  const { pricing, priorityBadge, wizardLoading } = useSelector((state) => ({
    // holidayDelivery: state.wizard.shipping?.main?.available_holiday_delivery,
    pricing: state.wizard.price_and_promo,
    priorityBadge: state.wizard.priorityBadge,
    wizardLoading: state.wizard.loading,
  }))
  const pdpPricingHierarchyExp = useSelector(
    (state) => state.experiment.pdpPricingHierarchy.variant_id
  )

  const { className: secondMicroBannerClassName, ...secondMicroBannerProps } =
    useSelector((state) => state.sale.second_microbanner?.style || {})

  const badgeContent = useMemo(() => {
    if (priorityBadge) {
      return (
        <>
          <FontAwesomeIcon
            className="text-8 tablet:text-16 mr-6 text-white"
            icon={faTag}
          />
          {priorityBadge.label}
        </>
      )
    }

    // if (holidayDelivery) {
    //   return `${sl.config.guaranteed_holiday_alias || sl.config.guaranteed_holiday} Delivery`
    // }

    if (pricing.on_sale) {
      const percentageSavings = (
        ((pricing.regular_pricing - pricing.price_to_display) * 100) /
        pricing.regular_pricing
      ).toFixed(0)

      return pdpPricingHierarchyExp === 1
        ? `${percentageSavings}% Off`
        : `SAVE ${percentageSavings}% OFF`
    }

    return null
  }, [priorityBadge, pricing])
  // }, [priorityBadge, pricing, holidayDelivery])

  if (wizardLoading || !Object.keys(pricing).length || !badgeContent) {
    return pdpPricingHierarchyExp === 1 ? null : (
      <Shimmer className="mb-10" style={{ height: "24px", width: "120px" }} />
    )
  }

  return (
    <div
      className={cn(
        pdpPricingHierarchyExp === 1
          ? cn(
              "text-12 bg-ruby flex h-20 items-center justify-center rounded-full px-8 font-semibold uppercase -tracking-tight text-white",
              secondMicroBannerClassName
            )
          : "bg-ruby text-12 tablet:text-14 tablet:leading-16 tablet:px-8 leading-14 inline-flex items-center justify-center rounded-md px-4 py-4 font-bold uppercase tracking-wide text-white"
      )}
      {...(pdpPricingHierarchyExp === 1 && secondMicroBannerProps)}
    >
      {badgeContent}
    </div>
  )
}

export default PriceBadge
